//frontend/src/pages/payments/MockPayment.jsx
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaymentComponent from '../../components/payments/PaymentComponent';
import MainLayout from '../../layouts/MainLayout';

const MockPayments = () => {
  const authState = useSelector(state => state.authReducer);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const loggedInUserName = authState.user.name;
  const itemPrice = 100.00;
  const itemID = 'Think5Whys Main Book';
  const itemName = 'Think5Whys Main BOK Book - Part 1/3';
  const itemDetails = 'Think5Whys Main BOK Book (Part 1/3) - Elevate Your Thinking From Why To Wisdom By Sanjeev Kumar';

  const handleBuyNow = () => {
    setShowPaymentModal(true);
  };
  

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>MockPayments</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
        {!showPaymentModal && (
          <button className='ml-5 w-2/12' onClick={handleBuyNow}>Buy Now</button>
        )}
        {showPaymentModal && <PaymentComponent onClose={() => setShowPaymentModal(false)} loggedInUserName={loggedInUserName} itemPrice={itemPrice} itemID={itemID} itemName={itemName} itemDetails={itemDetails}/>}
      </div>
    </MainLayout>
  );
};

export default MockPayments;
